import script from "./ArchivoCarga.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivoCarga.vue?vue&type=script&setup=true&lang=js"

import "./ArchivoCarga.vue?vue&type=style&index=0&id=1062be09&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1062be09"]])

export default __exports__